import React, {PureComponent} from "react"
import {get} from "lodash"

import {BasketTotal, Deal, PaymentCurrencyType} from "@irati/types"
import withBasket, {WithBasket} from "@irati/checkout/utils/basket/withBasket"
import calculateTotals from "@irati/checkout/utils/basket/helper/calculateTotals"
import OrderSummaryTT from "./Summaries/OrderSummaryTT"
import OrderSummaryStd from "./Summaries/OrderSummaryStd"

interface DefaultProps {
  email: string
  walletBalanceToUse: number
}

interface Props extends Partial<DefaultProps>, WithBasket {
  deal: Deal
  discount?: BasketTotal
  cashback?: BasketTotal
  flexiPointsCashbackRate?: number
  showSavingOptions?: boolean
  isMobile?: boolean
  walletBalanceToUse?: number
}

interface State {}

class OrderSummary extends PureComponent<Props, State> {
  state: State = {}

  static defaultProps: Partial<DefaultProps> = {
    email: "",
    walletBalanceToUse: 0
  }

  render() {
    const {deal, basket, walletBalanceToUse} = this.props
    const totals = calculateTotals(this.props.basket, walletBalanceToUse)
    const products = get(deal, "productConfig.products", [])

    switch (basket.breakdown.total.currency) {
      case PaymentCurrencyType.Rp:
      case PaymentCurrencyType.Tt:
        return <OrderSummaryTT {...this.props} totals={totals} products={products} />
      default:
        return <OrderSummaryStd {...this.props} totals={totals} products={products} />
    }
  }
}

export default withBasket(OrderSummary)
